<template>
  <NonScDrawer
    :open="
      drawer.open
    "
    @closed="
      () => drawer.open = false
    ">
    <template v-slot:body>
      <div
        class="
          editor-header
        ">
        <h4 class="editor-title" >
          {{ title }}
        </h4>
      </div>

      <div class="editor">
        <div
          v-if="
            mode == 'create'
          "
          class="
            editor-form
          ">
          <div class="group">
            <el-button
              v-for="
                (option, i) in options
              "
              :key="i"
              :type="
                'sc-asset'
              "
              :inactive="
                creator != option.value
              "
              @click="
                () => creator = option.value
              ">
              {{ option.name }}
            </el-button>
          </div>
        </div>

        <div
          v-if="
            mode != 'update-user'
          "
          class="editor-form">
          <div>
            <label>
              <i v-if="valid.role"
                class="
                  el-icon-circle-check valid
                "
              />
              <i v-else
                class="
                  el-icon-warning invalid
                "
              /> สถานะ
            </label>
            <br/>
            <div class="group">
              <el-button
                v-for="
                  (option, i) in role
                "
                :key="i"
                :type="
                  'sc-asset'
                "
                :inactive="
                  input.role != option.value
                "
                @click="
                  () => input.role = option.value
                ">
                {{ option.name }}
              </el-button>
            </div>
          </div>
        </div>

        <div
          v-if="
            creator == 'ADD'
          "
          class="
            editor-form
          "
          style="
            gap:0;
          ">
          <label>
            เลือกลูกบ้าน
          </label>
          <NonScUserSelector
            @select="
              value => select(value)
            "
          />
        </div>

        <div
          v-if="
            creator == 'NEW'
          "
          class="
            editor-form
          ">
          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.firstName"
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else
                  class="
                    el-icon-warning invalid
                  "
                /> ชื่อจริง
              </label>
              <input
                type="text"
                name="firstName"
                v-model="
                  input.firstName
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุชื่อจริง'
                "
              />
            </div>
            <div>
              <label>
                <i v-if="valid.lastName"
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else
                  class="
                    el-icon-warning invalid
                  "
                /> นามสกุล
              </label>
              <input
                type="text"
                name="lastName"
                v-model="
                  input.lastName
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุนามสกุล'
                "
              />
            </div>
          </div>
          
          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.mobileNo"
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else
                  class="
                    el-icon-warning invalid
                  "
                /> เบอร์มือถือ
              </label>
              <input
                type="text"
                name="mobileNo"
                v-model="
                  input.mobileNo
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุเบอร์มือถือ (10 หลัก)'
                "
              />
            </div>
            <div>
              <label>
                <i
                  v-if="
                    input.email && valid.email
                  "
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else-if="input.email"
                  class="
                    el-icon-warning invalid
                  "
                /> อีเมล์
              </label>
              <input
                type="text"
                name="email"
                v-model="
                  input.email
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุอีเมล์'
                "
              />
            </div>
          </div>
        </div>
        
      </div>

      <div
        class="
          editor-action group
        ">
        <el-button
          class="action"
          type="sc-asset"
          :disabled="
            !allow
          "
          @click="
            () => submit()
          ">
          บันทึก
        </el-button>
        <el-button
          v-if="
            mode == 'update' ||
            mode == 'update-user'
          "
          class="action"
          type="danger"
          @click="
            () => remove()
          ">
          ลบลูกบ้าน
        </el-button>
        <el-button
          class="action"
          type="info"
          @click="
            () => drawer.open = false
          ">
          ยกเลิก
        </el-button>
      </div>
    </template>
  </NonScDrawer>
</template>

<script lang="js">

// Components
import NonScDrawer from '../../components/NonScDrawer.vue'
import NonScUserSelector from '../../components/NonScUserSelector.vue'

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScUserCommon as UserCommon
} from '../../common/nonsc-user.common'

// Utils
import {
  ValidateUtility as Validate
} from '../../utils/validate'

export default {
  components: {
    NonScDrawer,
    NonScUserSelector,
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    form: {
      type: Object,
      default: () => UserCommon.input
    }
  },
  data() {
    return {
      creator: 'NEW',
      options: [
        { name: 'สร้างใหม่', value: 'NEW' },
        { name: 'ลูกบ้านที่มีอยู่', value: 'ADD' },
      ],
      drawer: {
        open: false
      },
      input: (
        Object.assign({}, UserCommon.input)
      )
    }
  },
  computed: {
    title() {
      return (
        this.mode == 'create'
          ? 'เพิ่มข้อมูลลูกบ้าน'
          : 'แก้ไขข้อมูลลูกบ้าน'
      )
    },
    role() {
      return Common.role
    },
    valid() {
      
      // Validator
      const valid = {
        email     : false,
        firstName : false,
        lastName  : false,
        mobileNo  : false,
        role      : false,
      }
      
      // Validate Input
      if (!this.input) return valid
      
      // Input Props
      const {
        firstName,
        lastName,
        mobileNo,
        email,
        role,
      } = this.input

      // Validate Role
      valid.role = (
        !!role && Validate.isRole(role)
      )

      // Validate Name
      valid.firstName = !!firstName
      valid.lastName = !!lastName

      // Validate Mobile Number
      valid.mobileNo = (
        !!mobileNo && Validate.isMobileNo(mobileNo)
      )

      // Validate Email
      valid.email = (
        email ? Validate.isEmail(email) : true
      )

      return valid
    },
    allow() {
      return Object.values(this.valid).every(e => e)
    }
  },
  watch: {
    form: {
      handler (value) {
        this.setInput(value)
      },
      deep: true
    },
    open(value) {

      // Validate State
      if (!value) return
      
      // Set Drawer
      this.drawer.open = value

      // Set Input
      if (value) {
        this.setInput(this.form)
      }
      else {
        setTimeout(
          this.setInput, 400
        )
      }

      // Reset Creator
      this.creator = 'NEW'
    },
    'drawer.open'(open) {
      if (!open) this.$emit('closed')
    },
    creator() {
      this.setInput()
    }
  },
  mounted() {
    
    // Set Drawer
    this.drawer.open = this.open

    // Set Form
    this.setInput(this.form)
  },
  methods: {
    setInput(value = { role: 'OWNER' }) {

      // Input Name
      const keys = (
        Object.keys(UserCommon.input)
      )

      // Map Input
      const form = keys.reduce(
        (e, key) => ({ ...e, [key]: value[key] }), {}
      )

      // Set Input
      this.input = (
        Object.assign({}, UserCommon.input, form)
      )

      // Input Props
      const { mobileNo } = this.input

      // Set Mobile Number
      if (mobileNo) {
        this.input.mobileNo = Common.toMobileNo(mobileNo)
      }
    },
    select(input) {

      // Validate Input
      if (!input) return
      
      // Input Key
      const keys = [
        'firstName',
        'lastName',
        'mobileNo',
        'email'
      ]

      // Set Input
      keys.forEach(
        e => this.input[e] = input[e]
      )

      // Format Mobile Number
      const mobileNo = Common.toMobileNo(
        this.input.mobileNo
      )

      // Set Mobile Number
      Object.assign(
        this.input, { mobileNo }
      )
    },
    create() {

      // Create Handler
      switch(this.creator) {
        case 'NEW': {
          this.$emit(
            'create-user', this.input
          )
        }
        break
        case 'ADD': {
          this.$emit(
            'create-role', this.input
          )
        }
        break
      }
    },
    remove() {

      // Emit Remove
      this.$emit(
        'remove-user', this.input
      )
      
      // Set Drawer
      this.drawer.open = false
    },
    submit() {
      
      // Mode Handler
      switch (this.mode) {
        case 'create': {
          this.create()
        }
        break
        case 'update':
        case 'update-user': {
          this.$emit(
            'update-user', this.input
          )
        }
        break
      }

      // Set Drawer
      this.drawer.open = false
    }
  }
}

</script>

<style lang="css" scoped>

.drawer-body {
  display         : flex;
  flex-direction  : column;
  height          : 100svh;
}

.editor {
  display     : grid;
  gap         : var(--size-sm);
  overflow-x  : hidden;
  overflow-y  : auto;
}

.editor-header,
.editor-action {
  padding: var(--size-lg);
}

.editor-title {
  margin: 0;
}

.editor-form {
  flex            : 1;
  display         : flex;
  flex-direction  : column;
  gap             : var(--size-sm);
  padding         : 0 var(--size-lg);
}

.editor-action {
  display: flex;
}

.group {
  display   : flex;
  gap       : var(--size-xs);
  flex-wrap : wrap;
}

.editor-action.group {
  gap: var(--size-md);
}

.el-button.action {
  min-width: 5rem;
}

@media screen and (max-width: 768px) {

  .editor-header,
  .editor-action {
    padding: var(--size-md);
  }

  .editor-form {
    padding: 0 var(--size-md);
  }

  .editor-title {
    text-align: right;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/user/NonScUserEditor.vue